import { useForm, Controller } from 'react-hook-form';
import ReactEDSWrapper from '../../../../utils/react-eds-wrapper';
import styles from './ReportFilters.module.css';
import { Button, Input, MenuItem, Select } from '@dsi/react-eds';
import { NiiReportContentResponse, ReportFiltersType } from '../shared/types/shared.types';

interface PropsObjects {
  report: NiiReportContentResponse;
  filters: ReportFiltersType[];
  transmitFilters: (values: Record<string, string>) => void;
  downloadReport: () => void;
}

function ReportFilters(props: Readonly<PropsObjects>) {
  const report = props.report;
  const filters = props.filters;
  const form = useForm();

  const filterChange = () => {
    props.transmitFilters(form.getValues());
  };

  const resetFilters = () => {
    form.reset();
    filterChange();
  };

  const handleDownload = () => {
    props.downloadReport();
  };

  const BOOLEAN_FILTER_ATTRIBUTES = ['cm_impact', 'new_alarms', 'kpi_deviations'];

  const getSelectItems = (attribute: string) => {
    if (BOOLEAN_FILTER_ATTRIBUTES.includes(attribute)) {
      return ['Yes', 'No'];
    }
    if (report?.filtersData) {
      return report.filtersData[attribute];
    }
    return [];
  };

  function getFilterField(filter: ReportFiltersType) {
    if (filter.type === 'select') {
      return (
        <Controller
          key={filter.name}
          name={filter.name}
          control={form.control}
          render={({ field }) => (
            <ReactEDSWrapper
              className={styles.fullSelect}
              component={Select}
              type="single"
              id={filter.name}
              key={JSON.stringify(field.value)}
              value={field.value || []}
              label={filter.label}
              onChange={(value) => {
                field.onChange(Array.isArray(value) ? value.pop() : value);
                filterChange();
              }}
            >
              {getSelectItems(filter.attribute)?.map((item: string) => (
                <ReactEDSWrapper component={MenuItem} key={item} value={item}>
                  {item}
                </ReactEDSWrapper>
              ))}
            </ReactEDSWrapper>
          )}
        />
      );
    } else if (filter.type === 'input') {
      return (
        <Controller
          key={filter.name}
          name={filter.name}
          control={form.control}
          render={({ field }) => (
            <ReactEDSWrapper
              className={styles.inputField}
              component={Input}
              id={filter.name}
              type="text"
              placeholder={filter.label}
              {...field}
              onChange={(value) => {
                field.onChange(value);
                filterChange();
              }}
            />
          )}
        />
      );
    } else {
      return <></>;
    }
  }

  return (
    <form className={styles.form} onChange={filterChange}>
      <div className={`${styles.formRow} row`}>
        {filters.map((filter) => {
          return (
            <div className={`${styles.formControl}`} key={filter.attribute}>
              <label htmlFor={filter.name} className={styles.whiteText}>
                {filter.title}{' '}
              </label>
              {getFilterField(filter)}
            </div>
          );
        })}
        <div className={styles.buttonContainer}>
          <ReactEDSWrapper component={Button} onClick={resetFilters}>
            {' '}
            Reset{' '}
          </ReactEDSWrapper>
        </div>
        <div className={styles.buttonContainer}>
          <ReactEDSWrapper variant="primary" className="btn primary" component={Button} onClick={handleDownload}>
            <i className="icon icon-download-save"></i> Download{' '}
          </ReactEDSWrapper>
        </div>
      </div>
    </form>
  );
}
export default ReportFilters;
